import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "fs-5 mb-0" }
const _hoisted_3 = { class: "table table-hover align-middle" }
const _hoisted_4 = { class: "fs-5 mb-0" }
const _hoisted_5 = { class: "fs-6 mb-2" }
const _hoisted_6 = { class: "table table-hover align-middle" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "fs-5 mb-0" }
const _hoisted_9 = { class: "fs-6 mb-2" }
const _hoisted_10 = { class: "table table-hover align-middle" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "col-lg-4"
}
const _hoisted_13 = { class: "card h-100" }
const _hoisted_14 = { class: "card-body d-flex flex-column" }
const _hoisted_15 = { class: "card-title" }
const _hoisted_16 = { class: "card-text" }
const _hoisted_17 = { class: "mt-auto" }
const _hoisted_18 = { class: "bg-warning missing-feature" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_ProductDetailMinimalStock = _resolveComponent("ProductDetailMinimalStock")!
  const _component_ProductDetailMaximumOrderQuantity = _resolveComponent("ProductDetailMaximumOrderQuantity")!
  const _component_BackInStockNotifications = _resolveComponent("BackInStockNotifications")!
  const _component_BaseCardHeader = _resolveComponent("BaseCardHeader")!
  const _component_BaseCardBody = _resolveComponent("BaseCardBody")!
  const _component_BaseCard = _resolveComponent("BaseCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertError2, {
      error: _ctx.tabUI.getError()
    }, null, 8, ["error"]),
    (_ctx.AbilityContext.isAuthorizedForFeature('PHARMACY_SW_SYNC'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.stockInfo
        && _ctx.renderMinStockAndMaxOrderQuantityInSeparateColumn
        && (_ctx.AbilityContext.isAuthorizedForFeature('PRODUCT_MINIMAL_STOCK')
          || _ctx.AbilityContext.isAuthorizedForFeature('PRODUCT_MAXIMAL_ORDER_AMOUNT')
          || _ctx.AbilityContext.isAuthorizedForFeature('BACK_IN_STOCK_NOTIFICATION'))
        && _ctx.AuthContext.isDpUser())
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(_ctx.widgetColumnClass)
              }, [
                _createVNode(_component_ProductDetailMinimalStock, { "product-code": _ctx.productCode }, null, 8, ["product-code"]),
                _createVNode(_component_ProductDetailMaximumOrderQuantity, { "product-code": _ctx.productCode }, null, 8, ["product-code"]),
                _createVNode(_component_BackInStockNotifications, { "product-code": _ctx.productCode }, null, 8, ["product-code"])
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.stockInfo?.catalog_stock_info)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(_ctx.widgetColumnClass)
              }, [
                (_ctx.stockInfo &&
        !_ctx.renderMinStockAndMaxOrderQuantityInSeparateColumn
        && _ctx.firstRenderedColumn === 0
        && (_ctx.AbilityContext.isAuthorizedForFeature('PRODUCT_MINIMAL_STOCK')
          || _ctx.AbilityContext.isAuthorizedForFeature('PRODUCT_MAXIMAL_ORDER_AMOUNT')
          || _ctx.AbilityContext.isAuthorizedForFeature('BACK_IN_STOCK_NOTIFICATION'))
        && _ctx.AuthContext.isDpUser())
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_ProductDetailMinimalStock, { "product-code": _ctx.productCode }, null, 8, ["product-code"]),
                      _createVNode(_component_ProductDetailMaximumOrderQuantity, { "product-code": _ctx.productCode }, null, 8, ["product-code"]),
                      _createVNode(_component_BackInStockNotifications, { "product-code": _ctx.productCode }, null, 8, ["product-code"])
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_BaseCard, { class: "catalog-stock text-bg-light border-light mb-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('catalogStock')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                      default: _withCtx(() => [
                        _createElementVNode("table", _hoisted_3, [
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('stockCount')), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.stockInfo.catalog_stock_info.stock_count ?? '-'), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('stockSize')), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.stockInfo.catalog_stock_info.stock_size?.description ?? '-'), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('registrationTimestamp')), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.stockInfo.catalog_stock_info.registration_timestamp)), 1)
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.stockInfo?.customers?.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(_ctx.widgetColumnClass)
              }, [
                (_ctx.stockInfo
        && !_ctx.renderMinStockAndMaxOrderQuantityInSeparateColumn
        && _ctx.firstRenderedColumn === 1
        && (_ctx.AbilityContext.isAuthorizedForFeature('PRODUCT_MINIMAL_STOCK')
          || _ctx.AbilityContext.isAuthorizedForFeature('PRODUCT_MAXIMAL_ORDER_AMOUNT')
          || _ctx.AbilityContext.isAuthorizedForFeature('BACK_IN_STOCK_NOTIFICATION'))
        && _ctx.AuthContext.isDpUser())
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_ProductDetailMinimalStock, { "product-code": _ctx.productCode }, null, 8, ["product-code"]),
                      _createVNode(_component_ProductDetailMaximumOrderQuantity, { "product-code": _ctx.productCode }, null, 8, ["product-code"]),
                      _createVNode(_component_BackInStockNotifications, { "product-code": _ctx.productCode }, null, 8, ["product-code"])
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_BaseCard, { class: "customer-stock text-bg-light border-light mb-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('pharmacySoftwareStock')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockInfo.customers, (customerStock, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "mb-3"
                          }, [
                            _createElementVNode("h4", _hoisted_5, _toDisplayString(customerStock.customer?.description ?? '-'), 1),
                            _createElementVNode("table", _hoisted_6, [
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('stockCount')), 1),
                                  _createElementVNode("td", null, _toDisplayString(customerStock.stock_info.stock_count ?? '-'), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('stockSize')), 1),
                                  _createElementVNode("td", null, _toDisplayString(customerStock.stock_info.stock_size?.description ?? '-'), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('registrationTimestamp')), 1),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(customerStock.stock_info.registration_timestamp)), 1)
                                ])
                              ])
                            ]),
                            (index < _ctx.stockInfo.customers.length - 1)
                              ? (_openBlock(), _createElementBlock("hr", _hoisted_7))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.stockInfo?.wholesalers?.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: _normalizeClass(_ctx.widgetColumnClass)
              }, [
                _createVNode(_component_BaseCard, { class: "wholesaler-stock text-bg-light border-light mb-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('wholesalerStock')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockInfo.wholesalers, (wholesalerStock, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "mb-3"
                          }, [
                            _createElementVNode("h4", _hoisted_9, _toDisplayString(wholesalerStock.customer?.description ?? '-') + " - " + _toDisplayString(wholesalerStock.wholesaler?.description ?? '-'), 1),
                            _createElementVNode("table", _hoisted_10, [
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('stockCount')), 1),
                                  _createElementVNode("td", null, _toDisplayString(wholesalerStock.stock_info.stock_count ?? '-'), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('stockSize')), 1),
                                  _createElementVNode("td", null, _toDisplayString(wholesalerStock.stock_info.stock_size?.description ?? '-'), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('registrationTimestamp')), 1),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(wholesalerStock.stock_info.registration_timestamp)), 1)
                                ])
                              ])
                            ]),
                            (index < _ctx.stockInfo.wholesalers.length - 1)
                              ? (_openBlock(), _createElementBlock("hr", _hoisted_11))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h5", _hoisted_15, _toDisplayString(_ctx.$t('catalogProductMgmtStock')), 1),
              _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('catalogProductMgmtStockDesc')), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('missingFeatureWarning')), 1)
              ])
            ])
          ])
        ]))
  ], 64))
}